// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_qKc","cls2":"LoswpTabsHero-cls2_s8C LoswpTabsHero-cls1_qKc","chip-on":"LoswpTabsHero-chip-on_0RO"};